import { render } from "./PostComment.vue?vue&type=template&id=2d912105&scoped=true"
import script from "./PostComment.vue?vue&type=script&lang=js"
export * from "./PostComment.vue?vue&type=script&lang=js"

import "./post-comment.scss?vue&type=style&index=0&id=2d912105&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d912105"]])

export default __exports__